import { render } from "./Produtos.vue?vue&type=template&id=2a8de8ee&scoped=true"
import script from "./Produtos.vue?vue&type=script&lang=js"
export * from "./Produtos.vue?vue&type=script&lang=js"

import "./Produtos.vue?vue&type=style&index=0&id=2a8de8ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8de8ee"]])

export default __exports__